import { FincasPlataformaService } from "../../../shared/generated/grpc/plataforma_terceros_fincas_pb";
import { GuardarOrtomosaicoPayload } from "../../../shared/services/api/payload/terceros/GuardarOrtomosaicoPayload";
import { grpcCall, grpcClient } from "../../../shared/services/grpc/grpcCall";

/** Encola la publicación del ortomosaico (`FincasPlataformaService.GuardarOrtomosaico`, gRPC). */
export class GuardarOrtomosaicoService {
  /** Asocia el ZIP ya subido y deja la finca en Pendiente (reenviar el mismo ZIP es reintentar). */
  static async guardar(payload: GuardarOrtomosaicoPayload): Promise<void> {
    await grpcCall(() => grpcClient(FincasPlataformaService).guardarOrtomosaico({ fincaId: payload.fincaId, blobUrl: payload.zipOrtomosaico }));
  }
}
